import React from "react";
import '../css/Sobre.css'
import sobreImg from '../img/sobre.jpg'

function Sobre() {
  window.addEventListener("scroll", function () {
    const upToTop = document.querySelector("a.bottom__to__top");
    upToTop.classList.toggle("active", window.scrollY > 0)
  });
  return (
    <div className="about component__space" id="Sobre">
      <div className="container">
        <div className="row">
          <div className="col__2">
            <img src={sobreImg} alt="" className="about__img"></img>
          </div>
          <div className="col__2">
            <h1 className="about__heading">Sobre mim</h1>
            <div className="about__meta">
              <p className="about__text p__color">
                Desenvolvo aplicações web utilizando as melhores práticas de Clean Code do mercado com as principais tecnologias da atualidade e uma cultura DevOps sólida.
              </p>
              <p className="about__text p__color">Atualmente estou fazendo o curso de Desenvolvimendo Web Full Stack na <a href="https://www.betrybe.com/">Trybe</a> </p>
              <p className="about__text p__color">Estou em busca do primeiro emprego na área da Tecnologia.</p>
              <div className="about__button d__flex align__items__center">
                <a href="https://pt.scribd.com/document/552444633/CV-Henrique-Junqueira-Braga-1">
                  <button className="about btn pointer">
                    Download CV
                  </button>
                </a>
                <a href="https://api.whatsapp.com/send?phone=5512981438324&text=Ol%C3%A1%20Henrique%2C%20vim%20atrav%C3%A9s%20do%20seu%20portf%C3%B3lio">
                  <button className="about btn pointer">
                    Whatsapp
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* botao UP */}
      <div className="up__to__top__btn">
        <a href="#Home" className="bottom__to__top">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-up white"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
            />
          </svg>
        </a>
      </div>
    </div>
  )
}

export default Sobre;
